export type SiteConfig = typeof siteConfig;

export const siteConfig = {
  name: '文献检索，用中文搜 PubMed',
  description:
    '探索超能文献，一款革命性的AI驱动医学文献搜索引擎。使用先进的大语言模型和NLP技术，Suppr能够理解复杂的医学查询，并从海量文献中快速定位到您所需的研究。体验中文搜索的便捷，告别传统PubMed语法，一键生成思维导图，轻松下载参考文献。',
  keywords: [
    '大模型医学论文搜索',
    '大模型医学文献搜索',
    '大模型生物医学论文搜索',
    '大模型临床试验论文搜索',
    '大模型SCI 论文搜索',
    '大模型文献搜索',
  ],
  tokenName: 'suppr.session-token',
};

export type SearchModel = 'pure_search' | 'regular' | 'flagship' | 'deep';

export const searchModels = [
  // {
  //   label: '纯搜索模式',
  //   value: 'pure_search',
  //   description: '',
  // },
  {
    label: '基础模式',
    value: 'regular',
    description: '轻量检索，快速返回结果',
    icon: 'Zap',
  },
  {
    label: '旗舰模式',
    value: 'flagship',
    description: '深度检索，覆盖更全面',
    icon: 'Sparkles',
  },
  {
    label: '专家模式',
    value: 'deep',
    description: '多轮自主检索，专家级准确率',
    icon: 'BrainCircuit',
  },
] as const;

export const deepResearchLangs = [
  {
    label: '简体中文',
    value: 'zh-cn',
  },
  {
    label: 'English',
    value: 'en',
  },
];

export enum FileType {
  PDF = 'pdf',
  HTML = 'html',
  DOCX = 'vnd.openxmlformats-officedocument.wordprocessingml.document',
  TEXT = 'plain',
  EXCEL = 'vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  PPTX = 'vnd.openxmlformats-officedocument.presentationml.presentation',
  EPUB = 'epub+zip',
  XHTML = 'xhtml+xml',
}

export const NEW_USER_RIGHTS = {
  transactionCount: '5万字',
};

export const DOMAIN = 'suppr.wilddata.cn';
